import React from "react";
import "./App.css";
import PeopleCards from "./components/PeopleCards/PeopleCards";
import CelebBooks from "./containers/CelebBooks";

function App() {
  return (
    <div className="App">
      <CelebBooks></CelebBooks>
    </div>
  );
}

export default App;
